// @flow
import React, { Component } from 'react';
import { Segment, Grid, Form, Header, Button, Checkbox } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import RuleBuilder from 'omega-rtc/components/rule-builder/RuleBuilder';
import RuleBuilderConfig from './TreatmentRuleBuilderConfig';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { getRuleTypesListForConditionNode } from 'utils/new-trident-utils';
import _ from 'lodash';
import i18n from 'i18n-js';
import './TreatmentForm.scss';
import { validateLHS } from 'omega-rtc/components/rule-builder/utils';
import Toastr from 'omega-rtc/utils/toastr-util';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  parentNode: string,
  parentKeyList: Array<string>,
  onModelChange: (_?: Object) => void,
  handleCloseModal: Function,
  handleInputChange: Function,
  handleControlBlur: Function,
  isAdd: boolean,
  handleDeleteNode: Function,
  listRuleTypes: Object,
};

@formComponent()
export default class ConditionForm extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      originalModel: this.props.model,
      currentNode: this.props.currentNode,
      startingNode: this.props.parentKeyList[0],
      parentNode: this.props.parentNode,
    };
  }

  handleLastOccurrenceChange = (event: any, data: any) => {
    const { checked } = data;
    const updatedModel = _.cloneDeep(this.props.model);
    if (checked === true) {
      const numberForLastOccurrence = _.get(updatedModel, 'recordLastOccurrenceKey') + 1;
      const occurrenceKey = 'T'.concat(numberForLastOccurrence.toString());
      _.set(updatedModel, `nodes.${this.state.currentNode}.recordLastOccurrenceKey`, occurrenceKey);
      _.set(updatedModel, 'recordLastOccurrenceKey', numberForLastOccurrence);
    } else {
      delete _.get(updatedModel, `nodes.${this.state.currentNode}`).recordLastOccurrenceKey;
    }
    this.props.onModelChange(updatedModel);
  };

  handleRuleChange = (data: Object) => {
    const updatedModel = _.cloneDeep(this.props.model);
    _.set(updatedModel.nodes[this.state.currentNode], 'data', data);
    this.props.onModelChange(updatedModel);
  }
  cancelCondition = () => {
    if (this.props.isAdd) {
      // eslint-disable-next-line no-alert
      const confirmValue = confirm('Cancel will delete this inactive node. Are you sure to delete this?');
      if (!confirmValue) return;
      this.props.handleDeleteNode(this.state.parentNode, this.state.currentNode, -1);
    } else {
      this.props.onModelChange(this.state.originalModel);
    }
    this.props.handleCloseModal();
  }
  saveCondition = () => {
    const { model, listRuleTypes } = this.props;
    const { ruleTypes } = getRuleTypesListForConditionNode(listRuleTypes, model, this.state.startingNode);
    const condition = _.get(this.props.model, `nodes.${this.state.currentNode}.data`, []);

    const errMsg = validateLHS(ruleTypes, condition);
    if (!_.isEmpty(errMsg)) {
      Toastr.error(errMsg);
      return;
    }
    this.props.handleCloseModal();
  }
  render() {
    const { model, listRuleTypes } = this.props;
    const { currentNode, startingNode } = this.state;
    const { ruleTypes, type } = getRuleTypesListForConditionNode(listRuleTypes, model, startingNode);
    const isRecordLastOccurrence = _.get(model, `nodes.${currentNode}.recordLastOccurrenceKey`, false);
    const disableCheckBox = _.get(model, `nodes.${currentNode}.children`, []).length > 0;
    return (
      <div>
        <div className="model-button">
          <Grid>
            <Grid.Column textAlign="right">
              <Button.Group>
                <Button
                  onClick={this.cancelCondition}
                >
                  Cancel
                </Button>
                <Button.Or />
                <Button
                  positive
                  onClick={this.saveCondition}
                >
                  Save
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
        <div className="treatment-form">
          <Segment className="treatment-form-segment">
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Condition Name</Header>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={12}>
                <Form>
                  <Grid>
                    <Grid.Column width={12}>
                      <FormInputWithError
                        name={'nodes.'.concat(`${currentNode}`, '.name')}
                        {...this.props}
                      >
                        <Form.Input
                          required
                          value={_.get(model, `nodes.${currentNode}.name`)}
                          onChange={this.props.handleInputChange}
                          onBlur={this.props.handleControlBlur}
                        />
                      </FormInputWithError>
                    </Grid.Column>
                  </Grid>
                </Form>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={8}>
                <Form.Field>
                  <Checkbox
                    name="recordLastOccurrence"
                    label="Record last occurrence"
                    onChange={this.handleLastOccurrenceChange}
                    checked={isRecordLastOccurrence}
                    disabled={disableCheckBox}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Builder</Header>
              </Grid.Column>
            </Grid>
            {/* code for condition builder */}
            <Grid>
              <Grid.Column width={16}>
                {type !== 'TREATMENTS.' && (
                  <FormInputWithError
                    name="condition"
                    {...this.props}
                  >
                    <RuleBuilder
                      key={`rule-builder-${type}`}
                      defaultValue={_.get(model, `nodes.${currentNode}.data`)}
                      onChange={this.handleRuleChange}
                      config={RuleBuilderConfig}
                      type={type}
                      systemType="newtrident"
                      ruleTypes={ruleTypes}
                      ruleTypesPassedFromSystem
                    />
                  </FormInputWithError>
                )}
                {type === 'TREATMENTS' && (
                  <span className="text-note">({i18n.t('targets_page.rules.placeholder')})</span>
                )}
              </Grid.Column>
            </Grid>
            <br />
          </Segment>
        </div>
      </div>
    );
  }
}
